var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1 3.8c-.8 0-1.5.6-1.5 1.5s.6 1.5 1.5 1.5 1.5-.6 1.5-1.5c.2-.9-.6-1.5-1.5-1.5zM3.9 16.2h2.6V8H3.9v8.2zm9.3-8.6s-2-.1-2.6 1.4V8H8.1v8.2h2.6v-4.5c0-.1 0-1.8 1.6-1.8 1.4 0 1.4 2 1.4 2v4.2h2.5v-4.9c-.1.2.3-3.6-3-3.6z"
  })));
};
export default SvgSocialLinkedin;